import RESERVED_CUSTOM_CODES from "./reservedCodes";

const __DEV__ = process.env.NODE_ENV === 'development';

const BACKEND_URL = __DEV__ ? 'http://127.0.0.1:5000' : process.env.REACT_APP_BACKEND_URL;

const GA4_MEASUREMENT_ID = process.env.REACT_APP_GA4_MEASUREMENT_ID;

const ENABLE_GA4 = !__DEV__;

const BACKEND_API_ENDPOINT = '/api/v1';

const UUT = 'User-Unique-Token';
const UUTLC = 'uut';  // UUT Local Storage
const THEME_HEADER = 'Theme';
const TIMEZONE_HEADER = 'Time-Zone';
const PRIMARY_COLOR_HEADER = 'Primary-Color';

const JWTLC = 'token';

const PROJECT_NAME = 'Shodl';
const PROJECT_DOMAIN = 'shodl.io';
const PROJECT_URL = `https://${PROJECT_DOMAIN}`
const CONTACT_EMAIL = 'contact@shodl.io';
const DEFAULT_PRIMARY_COLOR = '#4791DB';

const MAINTENANCE_MODE = process.env.REACT_APP_MAINTENANCE_MODE;

export {
    BACKEND_URL,
    BACKEND_API_ENDPOINT,
    __DEV__,
    UUT,
    UUTLC,
    THEME_HEADER,
    TIMEZONE_HEADER,
    PRIMARY_COLOR_HEADER,
    JWTLC,
    PROJECT_NAME,
    PROJECT_DOMAIN,
    PROJECT_URL,
    CONTACT_EMAIL,
    DEFAULT_PRIMARY_COLOR,
    MAINTENANCE_MODE,
    GA4_MEASUREMENT_ID,
    ENABLE_GA4,
    RESERVED_CUSTOM_CODES,
}